import actionTypes from './actions/actionTypes'

const {
  REQUEST_USERDATA,
  RECEIVE_USERDATA,
  REQUEST_TOKENVALIDITY,
  RECEIVE_TOKENVALIDITY,
  USER_VALIDITY,
  SERVER_ERROR_OCURED,
  LOG_OUT,
  SHOULD_REDIRECT,
  SHOULD_REDIRECT_LOGIN,
  SEMINAR_UPGRADE_MODAL,
  TOGGLE_SIDEBAR,
  UPDATE_VIEW,
  TOGGLE_FV_DOMAIN_SIDEBAR
} = actionTypes

const loginLayoutReducer = (
  state = {
    isCheckingUser: false,
    isCheckingToken: false,
    user: {},
    open: false,
    profile: {
      userid: null,
      name: null,
      role: null,
      email: null,
      accountType: null,
      stripeAccount: null,
      userLanguauge: 'jp',
      timezone: null
    },
    hasErrored: false,
    userExists: false,
    logoutSuccess: false,
    shouldRedirect: false,
    redirectToLogin: false,
    tokenVerified: false,
    openSidebar: true,
    openFvDomainSidebar: true,
    view: 'desktop'
  },
  action
) => {
  switch (action.type) {
    case REQUEST_USERDATA:
      return Object.assign({}, state, {
        tokenVerified: false,
        isCheckingUser: true,
        hasErrored: false
      })
    case RECEIVE_USERDATA:
      return Object.assign({}, state, {
        tokenVerified: true,
        isCheckingUser: false,
        user: action.user,
        profile: {
          userid: action.user.id,
          name: action.user.name,
          role:
            action.user.plan === 'free_guest' || action.user.plan === 'free' || action.user.plan === 'guest'
              ? 'Guest'
              : 'Adminstrator',
          email: action.user.email,
          accountType: action.user.plan,
          stripeAccount: action.user.stripe_account,
          cancellationDate: action.user.cancellation_date,
          nextInvoiceDate: action.user.next_invoice_date,
          failedPaymentDate: action.user.failed_payment_date,
          failedPaymentCount: action.user.failed_payment_count,
          userLanguauge:
            action.user.language && action.user.language === 'jp' ? 'ja' : 'en',
          timezone: action.user.timezone
        },
        hasErrored: false
      })
    case REQUEST_TOKENVALIDITY:
      return Object.assign({}, state, {
        isCheckingToken: true
      })
    case RECEIVE_TOKENVALIDITY:
      return Object.assign({}, state, {
        isCheckingToken: false
      })
    case USER_VALIDITY:
      return Object.assign({}, state, {
        userExists: action.userExists,
        hasErrored: false
      })
    case SEMINAR_UPGRADE_MODAL:
      return Object.assign({}, state, {
        open: action.open
      })
    case TOGGLE_SIDEBAR:
      return Object.assign({}, state, {
        openSidebar: action.value
      });
    case TOGGLE_FV_DOMAIN_SIDEBAR:
      return Object.assign({}, state, {
        openFvDomainSidebar: action.value
      });
    //view: action.view.width <= 900 ? 'mobile' : 'desktop'
    case UPDATE_VIEW:
      return Object.assign({}, state, {
        view: action.view.width >= 900 ?
          'desktop' :
          action.view.width >= 500 && action.view.width <= 900 ?
            'mobile' :
            'sm-mobile',
        openSidebar: action.view.width >= 900 ? true : state.openSidebar
      })
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasErrored: true
      })
    case LOG_OUT:
      return Object.assign({}, state, {
        tokenVerified: false,
        logoutSuccess: action.logoutSuccess,
        hasErrored: false
      })
    case SHOULD_REDIRECT:
      return Object.assign({}, state, {
        shouldRedirect: action.shouldRedirect,
        hasErrored: false
      })
    case SHOULD_REDIRECT_LOGIN:
      return Object.assign({}, state, {
        redirectToLogin: action.redirectToLogin,
        hasErrored: false
      })
    default:
      return state
  }
}

export default loginLayoutReducer



// WEBPACK FOOTER //
// src/layouts/LoggedIn/reducer.js